import { render, staticRenderFns } from "./barTableList.vue?vue&type=template&id=84f1f8a0&scoped=true&"
import script from "./barTableList.vue?vue&type=script&lang=js&"
export * from "./barTableList.vue?vue&type=script&lang=js&"
import style0 from "./barTableList.vue?vue&type=style&index=0&id=84f1f8a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f1f8a0",
  null
  
)

component.options.__file = "barTableList.vue"
export default component.exports